import * as fromBusquedaNissActions from '../../actions/AdmMapa/BusquedaNiss.actions';
import { DatosNiss } from 'src/app/models/SicarMap/DatosNiss.model';


export interface BusquedaNissState {
    action: string;
    datos: DatosNiss;
    loaded: boolean;
    loading: boolean;
    visibleData: boolean;
    hiddenData: boolean;
    error: any;
}

const initialStateRedAgua: BusquedaNissState = {
    action: '',
    datos: null,
    loaded: false,
    loading: false,
    visibleData: false,
    hiddenData: false,
    error: null
};

export function BusquedaNissReducer(state = initialStateRedAgua, action: fromBusquedaNissActions.DataNissActions): BusquedaNissState {
    switch (action.type) {
        case fromBusquedaNissActions.GET_DATA_NISS:
            return {
                ...state,
                action: 'GetDataNiss',
                loading: true,
                loaded: false,
            };

        case fromBusquedaNissActions.GET_DATANISS_SUCCESS:
            return {
                ...state,
                action:'GetDataNissSucces',
                loading: false,
                datos: {...action.datos},
                loaded: true,
            };

        case fromBusquedaNissActions.GET_DATANISS_FAILURE:
            return {
                ...state,
                action:'GetDataNissFail',
                loaded: false,
                loading: false,
                error: {...action.error}
            };

        case fromBusquedaNissActions.VISIBLE_DATANISS:
            return {
                ...state,
                action:'DataNissVisible',
                visibleData: true,
                hiddenData: false
            };
        case fromBusquedaNissActions.HIDDEN_DATANISS:
            return {
                ...state,
                action:'DataNissHidden',
                visibleData: false,
                hiddenData: true
            };
      default: {
        return state;
      }
    }
  }
